import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../../CommonComponents/OPL/Button/Button';
import { SegmentedControl } from '../../../../../../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { AssetType, SelectedAsset } from '../../Beneficiaries.meta';

interface AssetTypesList {
  name: string;
  assetType: AssetType;
}

interface Props {
  filterAssetType: SelectedAsset;
  setFilterAssetType: Dispatch<SetStateAction<SelectedAsset>>;
  assetTypesList: AssetTypesList[];
}

export const BeneficiariesActions = ({
  filterAssetType,
  setFilterAssetType,
  assetTypesList,
}: Props) => {
  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" css="gap: 16px">
          {assetTypesList.map(({ name, assetType }) => (
            <Button
              key={name}
              variant={`${filterAssetType.assetType === assetType ? 'primary' : 'subtleActive'}`}
              onClick={() => {
                setFilterAssetType(state => ({
                  ...state,
                  assetType,
                }));
              }}
            >
              {name}
            </Button>
          ))}
        </Box>

        <Box width={340}>
          {filterAssetType.assetType !== AssetType.EquityCompensation && (
            <SegmentedControl
              id="Beneficiaries-Review"
              values={['Current', 'Simulated']}
              selectedIndex={filterAssetType.isSimulated ? 1 : 0}
              onChange={index => {
                setFilterAssetType(state => ({
                  ...state,
                  isSimulated: index !== 0,
                }));
              }}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
